import AccesPmrTc from "./indicators/AccesPmrTc";
import AccidentsRoutes from "./indicators/AccidentsRoutes";
import EmissionCo2 from "./indicators/EmissionCo2";
import EmissionPm from "./indicators/EmissionPm";

const ChallengeThree = {
    idSection: "challengeThree",
    titleSection:
        "SUMP Trajectory Content.challenges.challenge3.challengeTitle",
    objectives: {
        objective1: {
            titleObjective:
                "SUMP Trajectory Content.challenges.challenge3.objectives.objective1",
            indicators: { accidentsRoutes: AccidentsRoutes },
        },
        objective2: {
            titleObjective:
                "SUMP Trajectory Content.challenges.challenge3.objectives.objective2",
            indicators: { accesPmrTc: AccesPmrTc },
        },
        objective3: {
            titleObjective:
                "SUMP Trajectory Content.challenges.challenge3.objectives.objective3",
            indicators: { emissionPm: EmissionPm, emissionCo2: EmissionCo2 },
        },
    },
};

export default ChallengeThree;
